<template>
  <!-- Question index -->
  <div class="flex items-center justify-between">
    <h3 class="text-lg font-bold">
      {{ index + 1 }}. {{ model.question }}
    </h3>


<!--    <div class="flex items-center">-->
<!--      &lt;!&ndash; Add new question &ndash;&gt;-->
<!--      <Button icon="pi pi-plus" label="Add" class="p-button-success" @click="addQuestion()" />-->
<!--      &lt;!&ndash;/ Add new question &ndash;&gt;-->

<!--      &lt;!&ndash; Delete question &ndash;&gt;-->
<!--      <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="deleteQuestion()" />-->
<!--      &lt;!&ndash;/ Delete question &ndash;&gt;-->
<!--    </div>-->
  </div>
  <!--/ Question index -->
  <div class="gap-3 grid-cols-12 col-span-9">
    <div class="mt-3 col-span-9">
      <label class="block text-sm font-medium text-gray-700">Question Text</label>
      <InputText v-model="model.question" @change="dataChange" class="mt-1 w-full" />
    </div>

    <div class="mt-3 col-span-3">
      <label class="block text-sm font-medium text-gray-700">Select Question Type</label>
      <Dropdown :options="formattedQuestionTypes" v-model="selectedType" @change="typeChange" optionLabel="name" class="mt-1 w-full" />
    </div>
  </div>



  <!--/ Question Description -->
  <div class="mt-3 col-span-9">
    <label :for="'question_description_' + model.id"
           class="block text-sm font-medium text-gray-700">Description</label>
    <Textarea
        v-model="model.description"
        :name="'question_description_' + model.id"
        :id="'question_description_' + model.id"
        @change="dataChange" class="mt-1 w-full" rows="3" />
  </div>

  <!-- Options Management -->

  <!-- Data -->
  <div v-if="shouldHaveOptions" class="mt-3">
    <h4 class="text-sm font-semibold mb-1 flex justify-between items-center">
      Options
      <Button icon="pi pi-plus" label="Add Option" class="ml-2 p-button-success" @click="addOption()" />
    </h4>
    <div
        v-if="model.data.options && !model.data.options.length"
        class="text-xs text-gray-600 text-center py-3"
    >
      You don't have any options defined
    </div>
    <div  v-for="(option, index) in model.data.options" :key="option.uuid" class="flex items-center mb-2">
      <span style="width: 3% !important;" class="text-sm"> {{ index + 1 }}. </span>

      <InputText v-model="option.text" @change="dataChange" class="mr-2 flex-1" />
      <Button icon="pi pi-trash" @click="removeOption(option)" class="p-button-danger" />
    </div>
  </div>
  <!--/ Data -->

  <hr class="my-4" />
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import store from "@/store";

export default {
  props: {
    question: Object,
    index: Number,
  },
  data() {
    return {
      model: JSON.parse(JSON.stringify(this.question)),
      selectedType: { name: null }

    };
  },
  computed: {
    questionTypes() {
      return store.state.questionTypes;
    },
    formattedQuestionTypes() {
      return this.questionTypes.map(type => ({ name: this.upperCaseFirst(type) }));
    },
    shouldHaveOptions() {
      return ["Select", "Radio", "Checkbox"].includes(this.model.type);
    }
  },
  methods: {
    upperCaseFirst(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    getOptions() {
      return this.model.data.options;
    },
    setOptions(options) {
      this.model.data.options = options;
    },
    addOption() {
      this.setOptions([
        ...this.getOptions(),
        { uuid: uuidv4(), text: "" },
      ]);
      this.dataChange();
    },
    removeOption(op) {
      this.setOptions(this.getOptions().filter((opt) => opt !== op));
      this.dataChange();
    },
    typeChange(event) {
      this.model.type = event.value.name;
      this.selectedType.name = event.value.name;
      if (this.shouldHaveOptions) {
        this.setOptions(this.getOptions() || []);
      }
      this.dataChange();
    },

    dataChange() {
      const data = this.model;
      if (!this.shouldHaveOptions) {
        delete data.data.options;
      }
      this.$emit("change", data);
    },
    // addQuestion() {
    //   this.$emit("addQuestion", this.index + 1);
    // },
    // deleteQuestion() {
    //   this.$emit("deleteQuestion", this.question);
    // }
  }
}
</script>

<style></style>
